import { ModalWrapper, NewModalBodyWrapper, SmallContentContainer } from '@mews-commander/ui';
import { useResolveRoute } from '@mews/routing';
import { RouteName } from '@mews-commander/enums';
import { LocalizedProperty, lt, useUUID } from '@mews/framework';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { getServiceNames } from '@mews-commander/legacy-entities/src/ducks/services';
import { useCurrentEnterprise } from '@mews-commander/legacy-entities/src/enterprise';
import { FormLanguageProvider } from '@mews-commander/legacy-form';
import { useCommanderSelector } from '@mews-commander/utils';
import ModalHeader from '../../legacy/React/Components/Common/ModalHeader';
import { Breadcrumbs } from '../../components/BreadcrumbList';
import { RateGroupCreateForm } from './RateGroupCreateForm';

interface RateGroupCreateViewProps {
    serviceId: string;
}

export const RateGroupCreateView = ({ serviceId }: RateGroupCreateViewProps) => {
    const formScope = `rate-group-create-${useUUID()}`;

    const resolveRoute = useResolveRoute();
    const currentEnterpriseId = useCurrentEnterpriseId();
    const { name: enterpriseName } = useCurrentEnterprise();
    const serviceName = useCommanderSelector((state) => getServiceNames(state, { id: serviceId })) as Record<
        string,
        string
    >;

    const breadcrumbs: Breadcrumbs = [
        {
            text: enterpriseName,
            url: resolveRoute(RouteName.EnterpriseDetail, { enterpriseId: currentEnterpriseId }),
        },
        {
            text: lt('ServicePlural'),
            url: resolveRoute(RouteName.ServiceIndex, { query: { OwnerId: currentEnterpriseId } }),
        },
        {
            text: <LocalizedProperty property={serviceName} />,
            url: resolveRoute(RouteName.VisitDetail, { serviceId }),
        },
        {
            text: lt('RateGroupPlural'),
            url: resolveRoute(RouteName.RateGroupIndex, { query: { OwnerId: serviceId } }),
        },
        { text: lt('RateGroup'), active: true },
    ];

    return (
        <ModalWrapper>
            <ModalHeader breadcrumbs={breadcrumbs} />
            <NewModalBodyWrapper>
                <SmallContentContainer>
                    <FormLanguageProvider>
                        <RateGroupCreateForm form={formScope} serviceId={serviceId} />
                    </FormLanguageProvider>
                </SmallContentContainer>
            </NewModalBodyWrapper>
        </ModalWrapper>
    );
};
